module.exports = "textarea {\r\n    resize: none;\r\n}"